import React from 'react';
import styled from 'styled-components';

import Help from 'icons/help';

// The "?" button every consumer uses to show or hide a license's SeatSummary in place. Shared
// so the Manage License and License Detail modals trigger the summary identically: a click on
// this button, not a hover. Consumers own the expanded state and render SeatSummaryPanel around
// a SeatSummary when it is true.
const HelpButton = styled.button`
  display: inline-flex;
  padding: 0;
  border: none;
  background: none;
  font-size: 20px;
  line-height: 1;
  color: ${({ theme }) => theme.colors.cloudTeal};
  cursor: pointer;
`;

export interface SeatSummaryHelpButtonProps {
  expanded: boolean;
  onClick: () => void;
  className?: string;
}

export const SeatSummaryHelpButton = ({
  expanded,
  onClick,
  className,
}: SeatSummaryHelpButtonProps): React.ReactElement => (
  <HelpButton
    type="button"
    className={className}
    aria-label="License seat summary"
    aria-expanded={expanded}
    title="License seat summary"
    onClick={onClick}
  >
    <Help />
  </HelpButton>
);

export const SeatSummaryPanel = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.cloudTeal};
  border-radius: 4px;
`;
